<template>
  <div>
    <b-table responsive="sm" :items="items" :fields="fields">
      <template #cell(media_path)="data">
        <div v-if="data.item.media === 'video'">
           <video width="100%" height="100" controls>
              <source :src="appUrl + '/' + data.value" type="video/mp4">
              Your browser does not support the video tag.
           </video>
        </div>
        <div v-else>
           <b-img width="100%" :src="appUrl + '/' + data.value"></b-img>
        </div>
      </template>

      <template #cell(title)="data">
        {{ data.value }}
      </template>

      <template #cell(action)="data">
        <b-row>
          <b-col md="auto">
            <b-button variant="success" @click="openUpdateModal(data.item)">
              <feather-icon icon="EditIcon" class="mr-25" />
            </b-button>
          </b-col>
          <b-col md="auto">
            <b-button variant="danger" @click="deletePost(data.item.id)">
              <feather-icon icon="DeleteIcon" class="mr-25" />
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-table>

    <b-modal
      ref="updatemodal"
      v-model="show"
      hide-footer
      title="Update Post"
    >
      <UpdatePost :updatingdata="selectedItem" />
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BTable,
  BButton,
  BCol,
  BRow,
  BImg,
} from "bootstrap-vue";
import UpdatePost from "./UpdatePost.vue";
import postApi from "@/Api/Modules/posts";
import { $themeConfig } from "@themeConfig";

export default {
  name: "PostTable",
  components: {
    BModal,
    BImg,
    BButton,
    BCol,
    BRow,
    UpdatePost,
    BTable,
  },
  data() {
    return {
      show: false,
      selectedItem: {},
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "media_path",
          label: "Preview",
          sortable: false,
          thStyle: { width: "15%" },
        },
        {
          key: "media",
          label: "Type", 
          sortable: true,
        },
        {
          key: "title",
          label: "Post Title",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
        },
      ],
      items: [],
    };
  },
  setup() {
    const { appUrl } = $themeConfig.app;
    return {
      appUrl,
    };
  },
  async created() {
    await this.getAllPosts();
  },

  methods: {
    async getAllPosts() {
      await this.$vs.loading({
        scale: 0.8,
      });

      try { 
        const res = await postApi.AllPosts();
        
       
        this.items = res.data && res.data.data ? res.data.data : res.data; 
        
      } catch (error) {
        console.error("Error fetching posts:", error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async deletePost(id) {
      if(confirm("Are you sure?")) {
          await this.$vs.loading({ scale: 0.8 });
          await postApi
            .DeletePost(id)
            .then(() => {
              this.$vs.loading.close();
              // API file usually reloads page, but if not:
              // this.getAllPosts(); 
            })
            .catch(() => {
              this.$vs.loading.close();
            });
      }
    },
    openUpdateModal(item) {
      this.selectedItem = item;
      this.show = true;
    },
  },
};
</script>